import { useEffect, useState } from "react";

import { fetchArcThumbnail } from "lib/orgServer/OrgServerClient";

/**
 * Resolve an ARC thumbnail hash to a displayable blob URL.
 * Returns undefined while loading, null when there is no thumbnail (or it
 * failed to load, so the card falls back to its default image).
 */
export const useArcThumbnail = (
    serialNumber: string,
    thumbnailHash: string | null | undefined
): string | null | undefined => {
    const [url, setUrl] = useState<string | null | undefined>(undefined);

    useEffect(() => {
        if (thumbnailHash === undefined) {
            setUrl(undefined);
            return;
        }
        if (thumbnailHash === null) {
            setUrl(null);
            return;
        }
        let objectUrl: string | null = null;
        let cancelled = false;
        setUrl(undefined);
        fetchArcThumbnail(serialNumber, thumbnailHash)
            .then((blob) => {
                if (cancelled) return;
                objectUrl = URL.createObjectURL(blob);
                setUrl(objectUrl);
            })
            .catch((err) => {
                if (cancelled) return;
                console.error("[useArcThumbnail] fetch failed", serialNumber, err);
                setUrl(null);
            });
        return () => {
            cancelled = true;
            if (objectUrl) URL.revokeObjectURL(objectUrl);
        };
    }, [serialNumber, thumbnailHash]);

    return url;
};
